<form *ngIf="fields" [formGroup]="addEditForm" (ngSubmit)="saveOrUpdate(dialogBoxEducation)" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid" >
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.title}">{{ fields.title.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="title" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.title"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.description}">{{ fields.description.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="description" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.description"></app-validation-msg>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="text-align: center; border: none;">
      <button
      class="k-generic-btn"
      type="submit" pButton
      icon="fa fa-check"
      label="{{('common.save' | translate)}}"
      ></button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/education/educationForm.html